import React, { FC, useState, ChangeEvent, FormEvent } from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { ReactComponent as SearchIcon } from '../../../assets/icons/search.svg'
import styles from './Search.module.scss'
import { ReactComponent as FilterIcon } from '../../../assets/icons/filter.svg'

type Props = {
    onSearch?: (search: string) => void
    classes?: {
        root?: string
        form?: string
        icon?: string
        input?: string
    }
    onFilter?: () => void
}

const Search: FC<Props> = ({ onSearch, classes = {}, onFilter }) => {
    const { t } = useTranslation()
    const [search, setSearch] = useState('')

    const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
        setSearch(event.target.value)
    }

    const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault()

        onSearch && onSearch(search)
    }

    return (
        <div className={classNames(styles.root, classes.root)}>
            {!!onFilter && (
                <div onClick={onFilter} className={styles.filter}>
                    <FilterIcon />
                </div>
            )}
            <form
                className={classNames(styles.form, classes.form)}
                onSubmit={handleSubmit}
            >
                <SearchIcon className={classNames(styles.icon, classes.icon)} />
                <input
                    className={classNames(styles.input, classes.input)}
                    placeholder={t('459_Search_search')}
                    value={search}
                    onChange={handleSearchChange}
                />
            </form>
        </div>
    )
}

export default Search
